
import { Route } from "react-router-dom";
import MenuCreacion from "./MenuCreacion";
import { getPrograma } from "../index";
import Crear from "./Crear";
import EditarPanel from "./Editar";
import ShortProvider from "../../../../Panel/Context/Shorts";
import LandingProvider from "./Context";
import { Ver } from "./Ver";
import { getKeyPrograma } from "./Keys/Programa";
import { getKeyCategoria } from "./Keys/Categoria";
import { findCategoria } from "../../../Context/Categorias";
export default function LandingProgama() {
    const c = getPrograma();
    const s = findCategoria(c.categoria)
    const k = getKeyPrograma(c).getKeys();
    const d = getKeyCategoria(s).getKeys();
    return <ShortProvider lista={[...k, ...d]}><LandingProvider>
        <Route path={`/programa/landing/${c.id}`} exact><Ver /></Route>
        <Route path={`/programa/landing/${c.id}/crear`} exact><MenuCreacion /></Route>
        <Route path={`/programa/landing/${c.id}/crear/:type`}><Crear /></Route>
        <Route path={`/programa/landing/${c.id}/edit/:mid`}><EditarPanel /></Route>
    </LandingProvider></ShortProvider >
}